"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useAction(action, deps) {
    var data = react_1.useRef({
        deps: undefined,
        cleanUp: undefined,
    }).current;
    var execute = shouldExecute(data.deps, deps);
    if (execute) {
        if (data.cleanUp)
            data.cleanUp();
        data.deps = deps;
        data.cleanUp = action();
    }
    react_1.useEffect(function () { return function () {
        if (data.cleanUp)
            data.cleanUp();
    }; }, []);
}
exports.useAction = useAction;
function shouldExecute(oldDeps, deps) {
    if (oldDeps === undefined || deps === undefined)
        return true;
    if (oldDeps.length !== deps.length)
        return true;
    var length = oldDeps.length;
    for (var i = 0; i < length; i++) {
        if (deps[i] !== oldDeps[i])
            return true;
    }
    return false;
}
